<template>
  <a v-show="isMobile" v-on:click="clickLink()">
    <img
      class="floating"
      :src="app_root + '/assets/common/img/creativeprint_icon.png'"
      style="width:70px;"
      alt="creativeprint_icon"
      v-on:click="launchApp"
    />
  </a>
</template>

<script>
import { APPLINK } from "@/common/creativeprintlink";
import { mapState } from "vuex";
export default {
  name: "CreativePrint",
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  computed:{
    ...mapState(["os"]),
    fcontid: function() {
      return this.$route.path.match(/\/\d+/).shift().slice(1)
    },
    isMobile: function() {
      return this.os == 'ios' || this.os == 'ard'
    }
  },
  methods: {
    clickLink: function () {
      //GA4
      const applink = APPLINK[this.fcontid];
      this.$gtag.event("go_app", {
        "app_name": "Creative Print",
        "article_no": this.fcontid,
        "print_type": "old",
        "design_id": applink.design_id,
        "site_id": "gallery"
      })
    },
    launchApp: function () {
      const pinfOption = `fcont_${this.fcontid}`;
      const applink = APPLINK[this.fcontid];

      const applicationtype = applink.apptype;
      switch (applicationtype) {
        case "launch": {
          this.launchCreativePrint(this.os, pinfOption);
          break;
        }
        case "print": {
          this.printCreativePrint(this.os, applink, pinfOption);
          break;
        }
      }
    },
    launchCreativePrint: function (clientDevice, pinfOption) {
      //Creative Print  アプリを起動
      switch (clientDevice) {
        case "ios": {
          const IOS_URLSCHEME = "com.epson.mobilephone.creative";
          const BASE_APPOPTION = "launch";
          const query = [
            { key: "source_app", value: `Epson.sn_${pinfOption}` }
          ];
          this.openIOSURL(IOS_URLSCHEME, BASE_APPOPTION, query);
          break;
        }
        case "ard": {
          const ANDROID_URLSCHEME = "com.epson.mobilephone.creative";
          const ANDROID_PACKAGE = "com.epson.mobilephone.creative";
          const query = [
            { key: "S.source_app", value: `Epson.sn_${pinfOption}` }
          ];
          this.openAndroidURL(ANDROID_URLSCHEME, ANDROID_PACKAGE, query);
          break;
        }
      }
    },
    printCreativePrint: function (clientDevice, applink, pinfOption) {
      switch (clientDevice) {
        case "ios": {
          const IOS_URLSCHEME = "com.epson.mobilephone.creative.designpaper.v1";
          const BASE_APPOPTION = "print";
          const query = [
            { key: "design_id", value: applink.design_id },
            { key: "angle", value: applink.angle },
            { key: "media_type", value: applink.media_type },
            { key: "media_size", value: applink.media_size },
            { key: "source_app", value: `Epson.sn_${pinfOption}` }
          ];
          this.openIOSURL(IOS_URLSCHEME, BASE_APPOPTION, query);
          break;
        }
        case "ard": {
          const ANDROID_URLSCHEME =
            "com.epson.mobilephone.creative.designpaper.v1";
          const ANDROID_PACKAGE = "com.epson.mobilephone.creative"; //S.source_app=Epson.sn.test1";

          const query = [
            { key: "S.design_id", value: applink.design_id },
            { key: "i.angle", value: applink.angle },
            { key: "i.media_type", value: applink.media_type },
            { key: "i.media_size", value: applink.media_size },
            { key: "S.source_app", value: `Epson.sn_${pinfOption}` }
          ];
          this.openAndroidURL(ANDROID_URLSCHEME, ANDROID_PACKAGE, query);
        }
      }
    },
    openIOSURL: function (scheme, appoption, query) {
      const IOSquery = query.map(q => `${q.key}=${q.value}`).join("&");
      const IOS_OPENURL = `${scheme}:///${appoption}?${IOSquery}`;
      window.location = IOS_OPENURL;
      this.$log.debug('url', IOS_OPENURL);
    },
    openAndroidURL: function (scheme, andpackage, query) {
      const Androidquery = query.map(q => `${q.key}=${q.value}`).join(";");
      const ANDROID_OPENURL = `intent://#Intent;scheme=${scheme};package=${andpackage};${Androidquery};end;`;
      window.location = ANDROID_OPENURL;
       this.$log.debug('url', ANDROID_OPENURL);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
